import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

export default function SearchBar({ size = "lg", testId = "home-search" }) {
    const [q, setQ] = useState("");
    const nav = useNavigate();
    const submit = (e) => {
        e.preventDefault();
        if (!q.trim()) return;
        nav(`/search?q=${encodeURIComponent(q.trim())}`);
    };
    const sizes = size === "lg"
        ? { wrap: "h-14", input: "text-base", btn: "h-14 px-7" }
        : { wrap: "h-11", input: "text-sm", btn: "h-11 px-5" };
    return (
        <form onSubmit={submit} className="w-full" data-testid={testId}>
            <div className="flex bg-white border border-stone-300 focus-within:border-sky-700">
                <div className={`flex-1 flex items-center px-4 ${sizes.wrap}`}>
                    <Search className="w-4 h-4 text-stone-400 mr-3 shrink-0" />
                    <Input
                        value={q}
                        onChange={(e) => setQ(e.target.value)}
                        placeholder="Search by name, symptoms (e.g. fever, anxiety) or medicine type"
                        className={`border-0 rounded-none focus-visible:ring-0 ${sizes.input} px-0 bg-transparent`}
                        data-testid={`${testId}-input`}
                    />
                </div>
                <Button type="submit" className={`rounded-none bg-sky-700 hover:bg-sky-800 text-stone-50 ${sizes.btn}`} data-testid={`${testId}-btn`}>Search</Button>
            </div>
        </form>
    );
}
